<p-button icon="pi pi-copy" (onClick)="onClick()">
</p-button>
